import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import {
  FillTheFieldErrorMessage,
  FormInput,
  FormTextArea,
  FormYearDatePicker,
} from "@/shared/Components";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const CareerField = ({ index, onBlur, onChange }: Props) => {
  const { t } = useTranslation();

  const handleBlur = useCallback(() => {
    onBlur?.();
    onChange?.();
  }, [onBlur]);

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`careers.${index}`} />
      <FormInput
        name={`careers.${index}.company`}
        placeholder={t("contactsPage.activities.company")}
        onBlur={handleBlur}
      />
      <FormInput
        name={`careers.${index}.jobTitle`}
        placeholder={t("contactsPage.activities.jobTitle")}
        onBlur={handleBlur}
      />
      <FormInput
        name={`careers.${index}.industry.name`}
        placeholder={t("contactsPage.activities.industry")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormYearDatePicker
        placeholder={t("common.dateFrom")}
        name={`careers.${index}.careerStart`}
        customOnChange={handleBlur}
      />
      <FormYearDatePicker
        placeholder={t("common.dateTo")}
        name={`careers.${index}.careerEnd`}
        customOnChange={handleBlur}
      />
      <FormTextArea
        name={`careers.${index}.about`}
        placeholder={t("common.about")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
    </FieldLayout>
  );
};
